<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Rakam"
    }
</script>

<style scoped>

</style>